import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`String representing a number which is greater than 0 and smaller than 1. It should start with `}<inlineCode parentName="p">{`0.`}</inlineCode>{` and should not end with `}<inlineCode parentName="p">{`0`}</inlineCode>{`. Valid examples: `}<inlineCode parentName="p">{`0.1`}</inlineCode>{`, `}<inlineCode parentName="p">{`0.123456`}</inlineCode>{`. Invalid examples: `}<inlineCode parentName="p">{`0`}</inlineCode>{`, `}<inlineCode parentName="p">{`1`}</inlineCode>{`, `}<inlineCode parentName="p">{`0.10`}</inlineCode>{`, `}<inlineCode parentName="p">{`0.1234560`}</inlineCode>{`, `}<inlineCode parentName="p">{`0.12345e7`}</inlineCode>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      